// extracted by mini-css-extract-plugin
export default {"root":"LoadingSpinner-module_root_de61cd","container":"LoadingSpinner-module_container_a9951f","fixedContainer":"LoadingSpinner-module_fixedContainer_bdb41c"};